module.exports = __webpack_public_path__ + "img/trial4-3.646979e7.png";